import { render, staticRenderFns } from "./boardecharts.vue?vue&type=template&id=f28f75f2&scoped=true"
import script from "./boardecharts.vue?vue&type=script&lang=js"
export * from "./boardecharts.vue?vue&type=script&lang=js"
import style0 from "./boardecharts.vue?vue&type=style&index=0&id=f28f75f2&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f28f75f2",
  null
  
)

export default component.exports